import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import { showModal } from "../../../store/slices/common";
import CustomTextField from "../../../components/Textfield";
import { modalVariant } from "../../../components/Modal/Modalutils";
import Button from "../../../components/Button";
import { changePassword } from "../../../http/auth";
import { deleteSessionData } from "../../../utils/auth-token-utils/cookie";
import Spinner from "../../../components/Spinner";
// import { changePassword } from '../../../http/auth';

function ChangePassword() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setloading] = useState(false);
  

  const initialValues = {
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  };

  const validationSchema = Yup.object({
    currentPassword: Yup.string("Enter your current password").required(
      "Required"
    ),
    newPassword: Yup.string()
      .required("Password is required")
      .min(8, "Password must have minimum 8 characters")
      // .max(50, "Password should not exceed 50 characters")
      .matches(/[A-Z]/, " Password must contain an uppercase")
      .matches(/[a-z]/, "Password must contain a lowercase")
      .matches(/[^\w]/, "Password must contain a special character")
      .matches(/[0-9]/, "Password must contain a number"),
    confirmPassword: Yup.string()
      .required("Confirm Password is required")
      .oneOf([Yup.ref("newPassword")], "Confirm password must match with new password"),
  });

  const formik = useFormik({
    initialValues,
    validationSchema,
    enableReinitialize: true,
    onSubmit: async (values) => {
      try {
        setloading(true);
        await changePassword({
          oldPassword: values.currentPassword,
          newPassword: values.newPassword,
        });
        dispatch(
          showModal({
            modalType: modalVariant.CHANGE_PASSWORD_SUCCESSFULL,
            resolveCallback: () => {
              dispatch(showModal(null));
              formik.resetForm();
              setloading(false);
              deleteSessionData();
              navigate("/");
            },
            rejectCallback: () => {
              dispatch(showModal(null));
              setloading(false);
            },
          })
        );
      } catch (error) {
        setloading(false);
      }
    },
  });

  const handleChange = (e) => {
    if (e.target.value?.length < 50) {
      formik.setFieldValue(e.target.name, e.target.value);
    }
  };

  return (
    <Box
      display="flex"
      maxWidth="380px"
      flexDirection="column"
      padding={{ xs: "0", md: "0 20px" }}
    >
      {loading && <Spinner />}
      <form onSubmit={formik.handleSubmit}>
        <Typography
          className="header"
          color="#687F89"
          width="100%"
          fontWeight="400"
          fontSize="16px"
        >
          Enter Old Password<span style={{ color: "red" }}>*</span>
        </Typography>
        <Box
          borderRadius="40px"
          display="flex"
          marginTop="15px"
          width="100%"
          flexDirection="column"
          justifyContent="center"
        >
          <CustomTextField
            type="password"
            name="currentPassword"
            placeholder="Old Password"
            value={formik.values.currentPassword}
            onChange={handleChange}
            onBlur={formik.handleBlur}
            error={
              formik.touched.currentPassword &&
              Boolean(formik.errors.currentPassword)
            }
            errorMessage={
              formik.touched.currentPassword && formik.errors.currentPassword
            }
          />
        </Box>
        <Typography
          className="header"
          color="#687F89"
          marginTop="24px"
          width="100%"
          fontWeight="400"
          fontSize="16px"
        >
          New Password <span style={{ color: "red" }}>*</span>
        </Typography>
        <Box
          borderRadius="40px"
          display="flex"
          marginTop="15px"
          width="100%"
          flexDirection="column"
          justifyContent="center"
        >
          <CustomTextField
            type="password"
            name="newPassword"
            placeholder="New Password"
            value={formik.values.newPassword}
            onChange={handleChange}
            onBlur={formik.handleBlur}
            error={
              formik.touched.newPassword && Boolean(formik.errors.newPassword)
            }
            errorMessage={
              formik.touched.newPassword && formik.errors.newPassword
            }
          />
        </Box>
        <Typography
          className="header"
          color="#687F89"
          marginTop="24px"
          width="100%"
          fontWeight="400"
          fontSize="16px"
        >
          Confirm Password<span style={{ color: "red" }}>*</span>
        </Typography>
        <Box
          borderRadius="40px"
          display="flex"
          marginTop="15px"
          width="100%"
          flexDirection="column"
          justifyContent="center"
        >
          <CustomTextField
            type="password"
            name="confirmPassword"
            placeholder="Confirm Password"
            value={formik.values.confirmPassword}
            onChange={handleChange}
            onBlur={formik.handleBlur}
            error={
              formik.touched.confirmPassword &&
              Boolean(formik.errors.confirmPassword)
            }
            errorMessage={
              formik.touched.confirmPassword && formik.errors.confirmPassword
            }
          />
        </Box>
        <Box
          borderRadius="40px"
          display="flex"
          marginTop="2rem"
          width="100%"
          flexDirection="column"
          justifyContent="center"
        >
          <Button
            style={{ marginTop: 0, width: "50%", minWidth: "150px" }}
            className="theme-btn-contained theme-btn theme-auth-btn"
            label="Save Changes"
            variant="contained"
            color="primary"
            typeButton="submit"
            disabled={
              !formik.values.currentPassword ||
              !formik.values.newPassword ||
              !formik.values.confirmPassword
            }
          />
        </Box>
      </form>
    </Box>
  );
}

export default ChangePassword;
